import React from 'react'
import { Radio } from 'antd'
import styled from '@emotion/styled'
import Text from '../../../../components/common/Text'
import { BACKGROUND, FONT_LIGHT_GRAY, INPUT_ERROR, PRIMARY } from '../../../../constant/colors'
import IconCoin from '../../../../assets/images/icons-coin-24-px.png'
import Image from '../../../../components/common/Image'
import { isNumber } from 'lodash'
import { useTranslation } from 'react-i18next'
import { numberWithCommas } from '../../../../utils/helper'
import { mobile, mobileVerySmall } from '../../../../utils/responsive-helper'
import HtmlWithStyled from '../../../../components/HtmlWithStyled'

const RadioLayout = styled.div`
  width: 100%;
  margin-left: 22px;
  .second {
    margin-bottom: 16px;
  }

  ${mobile} {
    margin-left: unset;
    .first {
      align-items: flex-start;
    }
    .second {
      margin-bottom: 8px;
    }
  }
  ${mobileVerySmall} {
    .first {
      flex-wrap: wrap;
      margin-bottom: 6px;
    }
  }
`

const Row = styled.div`
  width: 100%;
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: space-between;
`

const PointLayout = styled(Row)`
  width: unset;
  > *:not(:last-child) {
    margin-right: 8px;
  }
  .icon-coin {
    margin-right: 6px;
  }

  > *:nth-of-type(2) {
    text-align: end;
    width: 100%;
  }

  ${mobile} {
    align-items: flex-end;
    flex-flow: column;
    align-items: flex-start;
  }

  ${mobileVerySmall} {
    align-items: flex-end;
    flex-flow: row wrap;
    justify-content: flex-end;
    width: 100%;

    > *:not(:last-child) {
      margin-right: unset;
    }
    .icon-coin {
      margin-right: 4px;
    }

    > *:nth-of-type(1) {
      justify-content: flex-end;
    }
  }
`

const DescriptionLayout = styled(Row)`
  width: 100%;
  align-items: flex-end;
  > *:not(:last-child) {
    margin-right: 8px;
  }

  .benefit-description {
    width: 100%;
    white-space: normal;
    word-wrap: break-word;
    font-family: IBMPlexSansThai-Medium;
    font-size: 20px;
    font-weight: 300;
    color: #333333;

    * {
      width: inherit;
    }
  }

  ${mobile} {
    flex-flow: column;
  }
`

const StyledGroup = styled(Radio.Group)`
  width: 100%;
`
const StyledRadio = styled(Radio)`
  display: flex;
  flex-direction: row;
  align-items: flex-start;

  min-height: 50px;
  margin-bottom: 8px;
  margin-right: unset;
  padding: 24px 20px;

  border-color: ${BACKGROUND};
  border-radius: 8px;
  border-width: 1px;
  border-style: solid;

  span.ant-radio + * {
    display: flex;
    flex-direction: row;
    width: 100%;
  }

  .ant-radio {
    margin-top: 6px;
    .ant-radio-inner {
      width: 21px;
      height: 21px;
      ::after {
        top: 3px;
        left: 3px;
        width: 13px;
        height: 13px;
      }
    }
  }
  ${mobile} {
    padding: 16px;
    .ant-radio {
      margin-top: 6px;
    }
  }
`
type ChoicesRadioOption = BaseOptionType & {
  point?: number
  description?: string
  onSeeDetailClick?: () => void
}
type ChoicesRadioProps<V = BaseOptionType['value']> = {
  value?: V
  options: ChoicesRadioOption[]
  onChange: (value: V) => void
}

const ChoicesRadio = (props: ChoicesRadioProps) => {
  const { value, options, onChange } = props
  const { t } = useTranslation()
  return (
    <StyledGroup value={value ? Number(value) : undefined}>
      {options.map((option) => (
        <StyledRadio
          value={option.value}
          key={`${option.value}-${option.label}`}
          onClick={() => {
            onChange(option.value)
          }}
          style={{
            borderColor: value === option.value ? PRIMARY : BACKGROUND,
            borderWidth: value === option.value ? 2 : 2,
          }}
        >
          <RadioLayout>
            <Row className="first">
              <Text size={22} type="SemiBold">
                {option.label}
              </Text>
              <PointLayout>
                <Row>
                  <div className="icon-coin">
                    <Image src={IconCoin} />
                  </div>
                  <Text size={22} type="SemiBold" color={INPUT_ERROR}>
                    {isNumber(option.point) ? numberWithCommas(-option.point) : '-'}
                  </Text>
                </Row>
                <Text size={20} color={FONT_LIGHT_GRAY}>
                  {t('คะแนน')}
                </Text>
              </PointLayout>
            </Row>
            <Row className="second"></Row>
            <DescriptionLayout>
              {option.description && (
                <HtmlWithStyled className="benefit-description" html={option.description} />
              )}
            </DescriptionLayout>
          </RadioLayout>
        </StyledRadio>
      ))}
    </StyledGroup>
  )
}

export default ChoicesRadio
